import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import CandidateViewKnowledgeGraph from '../components/KnowledgeGraph/CandidateViewKnowledgeGraph';
import './CandidateKnowledgeGraph.css';

const CandidateKnowledgeGraph = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const emailParam = params.get('email');
  
  const { email } = useParams();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  // Prioritize URL param over localStorage for direct linking, then localStorage as fallback
  const candidateEmail = email || emailParam || localStorage.getItem('candidateProfileEmailID');

  // Check authentication
  useEffect(() => {
    const checkAuth = async () => {
      try {
        await Auth.currentAuthenticatedUser();
        setIsAuthenticated(true);
      } catch (error) {
        console.log('User not authenticated, redirecting to home');
        navigate('/');
        return;
      }
      setIsLoading(false);
    };

    checkAuth();
  }, [navigate]);

  if (isLoading) {
    return null; // Return null to show nothing, just the background
  }

  if (!isAuthenticated) {
    return null; // Will redirect via useEffect
  }  return (
    <div className="candidate-kg-page-wrapper">
      {/* Small Header */}
      <div className="candidate-kg-header">
        <h1 className="candidate-kg-title">Knowledge Graph</h1>
        {candidateEmail && (
          <p className="candidate-kg-subtitle">Analyzing: {candidateEmail}</p>
        )}
      </div>

      {/* Main Graph Area */}
      <div className="candidate-kg-graph-area-futuristic">
        <div className="candidate-kg-graph-wrapper-futuristic">
          {candidateEmail ? (
            <CandidateViewKnowledgeGraph 
              candidateEmail={candidateEmail}
              height="100%" // Use full available height
            />
          ) : (
            <div className="candidate-kg-no-data">
              <p>No candidate email provided</p>
            </div>
          )}
        </div>
      </div>

      {/* Small Footer */}
      <div className="candidate-kg-footer">
        <p>Powered by GetScreened AI</p>
      </div>
    </div>
  );
};

export default CandidateKnowledgeGraph;